import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import { setApiLocale } from '../api/client';
import type { Locale } from '../api/types';
import { en } from './locales/en';
import { zh } from './locales/zh';

export const SUPPORTED_LOCALES: Locale[] = ['zh', 'en'];
const STORAGE_KEY = 'mgr.locale';

export const LOCALE_LABELS: Record<Locale, string> = {
  zh: '简体中文',
  en: 'English',
};

function detectLocale(): Locale {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'zh' || stored === 'en') return stored;
  } catch {
    /* Storage unavailable — fall through to the browser preference. */
  }
  const preferred = navigator.languages?.find((language) =>
    SUPPORTED_LOCALES.some((locale) => language.toLowerCase().startsWith(locale)),
  );
  return preferred?.toLowerCase().startsWith('en') ? 'en' : 'zh';
}

export const initialLocale = detectLocale();

void i18next.use(initReactI18next).init({
  resources: {
    zh: { translation: zh },
    en: { translation: en },
  },
  lng: initialLocale,
  fallbackLng: 'zh',
  interpolation: { escapeValue: false },
  returnNull: false,
});

setApiLocale(initialLocale);
document.documentElement.lang = initialLocale === 'zh' ? 'zh-Hans' : 'en';

export async function changeLocale(locale: Locale) {
  await i18next.changeLanguage(locale);
  setApiLocale(locale);
  document.documentElement.lang = locale === 'zh' ? 'zh-Hans' : 'en';
  try {
    window.localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    /* Preference stays for this tab only. */
  }
}

export const currentLocale = (): Locale => (i18next.language?.startsWith('en') ? 'en' : 'zh');

export { i18next };
